import Loading from '../Loading.js';
import {Link} from 'react-router-dom';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import {apiService} from '../../common/apiCallService';
import {baseUrl} from '../../common/config.js';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class TournamentOverlayTypeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading : true,
            tournamentTypeTemplates : [],
            sortColumn : 'name',
            sortType : 'asc'
        }
    }

    componentDidMount() {
        createVirtualPageLoad("/tournamentType")
        this.props.setHeaderTitle('Tournament Type');
        this.getTournamentTypeTemplates()
            .then(_ => console.log(':: Data Completed ::'))
            .catch(_ => console.log(':: Something went wrong ::'))
    }
    
    componentWillUnmount() {
        closeVirtualPage()
      }

    getTournamentTypeTemplates = () => new Promise((resolve, reject) => {
        this.setState({loading : true})
        apiService( 
            baseUrl + '/tournamentoverlay/type/list', 
            {},
            data => {
                let tournamentTypeTemplates = data.sort(this.sortName('asc'));
                this.setState({tournamentTypeTemplates, loading : false}, resolve)
            },
            reject
        )
    });

    onSort = (colname) => {
        let {sortColumn, sortType, tournamentTypeTemplates} = this.state;
        if(sortColumn == colname && sortType != 'desc') sortType = 'desc'
        else sortType = 'asc'
        let sortFunction;
        if(colname == 'name' || colname == 'regExp') sortFunction = this.sortName(sortType,colname);
        else sortFunction = this.sortRegMinsAfterStart(sortType);

        this.setState({
            tournamentTypeTemplates : tournamentTypeTemplates.sort(sortFunction),
            sortColumn : colname,
            sortType
        })
    }

    sortName = (type,colname) => {
        return (a, b) => {
            let nameA = colname && colname!=='name' ? a[[colname]][0].toUpperCase():a.name.toUpperCase();
            let nameB = colname && colname!=='name' ? b[[colname]][0].toUpperCase():b.name.toUpperCase();
            if ((nameA < nameB && type == 'asc') || (nameA > nameB && type == 'desc')) {
            return -1;
            }
            if ((nameA < nameB && type == 'desc') || (nameA > nameB && type == 'asc')) {
            return 1;
            }
            return 0;
        }
    }

    sortRegMinsAfterStart = (type) => {
        return (a,b) => {
            if(type == 'asc') return a.regMinsAfterStart - b.regMinsAfterStart
            else if(type == 'desc') return b.regMinsAfterStart - a.regMinsAfterStart
        }
    }
    

    deleteTournament = (_id) => {
        apiService( 
            baseUrl + '/tournamentoverlay/type/delete', 
            {_id},
            _ => {
                
                this.getTournamentTypeTemplates()
                    .then(_ => console.log(':: Data Completed ::'))
                    .catch(_ => console.log(':: Something went wrong ::'))
            },
            err => {
                alert('something went wrong')
                this.getTournamentTypeTemplates()
                        .then(_ => console.log(':: Data Completed ::'))
                        .catch(_ => console.log(':: Something went wrong ::'))
            }
        )
    }
    render() {
        // console.log(this.state.tournamentTypeTemplates)
        return(
            <div>
                {this.state.loading ?
                    <Loading/> : 
                    <div >
                        <Paper zDepth={1} rounded={false} className="resp-paper"  style={{marginLeft:'0px',marginRight:'0px'}}>
                        
                            <Link  style={{textDecoration:"none"}}  to={'/tournamentupsert/0'}>
                                
                                <RaisedButton
                                    label="Add New Type"data-e2e="addnewtype"
                                    primary={true}
                                    style = {{float : 'right'}} 
                                />
                                
                            </Link>
                          
                            <table className="resp-table resp-table-background">
                                <thead className="resp-table-head">
                                    <tr className="resp-table-tr">
                                        <th onTouchTap={_ => this.onSort('name')} className="resp-table-th" >Name&nbsp;
                                            <i className="fa fa-sort "data-e2e="tournment-name" ></i>
                                        </th>
                                        <th  onTouchTap={_ => this.onSort('regMinsAfterStart')} className="resp-table-th">Mins to Start&nbsp;
                                            <i className="fa fa-sort "data-e2e="minstostarts" ></i>
                                        </th>
                                        <th  onTouchTap={_ => this.onSort('regExp')} className="resp-table-th">Mins to Register&nbsp;
                                            <i className="fa fa-sort " ></i>
                                        </th>
                                        <th className="resp-table-th">
                                        </th>
                                        <th className="resp-table-th">
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="resp-table-body">
                                    {this.state.tournamentTypeTemplates.map((tournamentType, key) => 
                                        <tr key={key} className="resp-table-tr">
                                            <td className="TournamentWatch resp-table-td">{tournamentType.name}</td>
                                            <td className="TournamentWatch resp-table-td">{tournamentType.regMinsAfterStart}</td>
                                            <td className="TournamentWatch resp-table-td">{tournamentType.regExp.join(', ')}</td>
                                            <td className="TournamentWatch resp-table-td">
                                                <Link  style={{textDecoration:"none"}}  to={'/tournamentupsert/'+tournamentType._id}>
                                                    <RaisedButton data-e2e="view-button"
                                                        label="View"
                                                        primary={true}
                                                    />
                                                </Link>
                                            </td>
                                            <td className="TournamentWatch resp-table-td">
                                                <RaisedButton
                                                    label="Delete"
                                                    primary={true}
                                                    onClick = {_ => this.deleteTournament(tournamentType._id)}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Paper>
                    </div>
                    
            }
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
      setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
    }
  };
  
export default connect(null, mapDispatchToProps)(TournamentOverlayTypeList);



/** WEBPACK FOOTER **
 ** ./src/components/TournamentOverlay/TournamentOverlayTypeList.js
 **/